/**
 * Bot/Crawler detection utility.
 * Prevents WebSocket connections from being initiated by search engine crawlers
 * (Googlebot, Bingbot, etc.) which don't support WebSocket and cause
 * ERR_NAME_NOT_RESOLVED errors reported in Google Search Console.
 */
export function isBot(): boolean {
  if (typeof navigator === 'undefined') return true;
  return /Googlebot|bingbot|Baiduspider|YandexBot|Slurp|DuckDuckBot|facebookexternalhit|Twitterbot|LinkedInBot|Applebot|crawler|spider|robot|prerender|headless|puppeteer|chrome-lighthouse|pagespeed|pingdom|gtmetrix|google-structured-data|validator|\+http/i.test(navigator.userAgent);
}
